import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {
    createBrowserRouter,
    RouterProvider,
  } from "react-router-dom";
import ErrorPage from './components/Error';
import Smeshers from './components/Smeshers';
import Transactions from './components/Transactions';
import Accounts from './components/Accounts';
import Network, {loader as networkLoader} from './components/Network'
import Account, {loader as accountLoader} from './components/Account';
import Transaction, {loader as transactionLoader} from './components/Transaction';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

  const router = createBrowserRouter([
    {
      path: "/",
      element: <App />,
      errorElement: <ErrorPage />,
      children: [
        {
            index: true,
            element: <Network />,
            loader: networkLoader,
        },
        {
            path: "/smeshers",
            element: <Smeshers />,
            children: [
                {
                    path: ":smesherid",
                    element: <h1>Smesher ID DATA</h1>
                }
            ]
        },
        {
            path: "/transactions",
            element: <Transactions />,
            children: [
                {
                    path: ":transactionid",
                    element: <Transaction />,
                    loader: ({ params }) => transactionLoader(params)
                }
            ]
        },
        {
            path: "/accounts",
            element: <Accounts />,
            children: [
                {
                    path: ":accountid",
                    element: <Account />,
                    loader: ({ params }) => accountLoader(params)
                }
            ]
        }
      ]
    }
  ]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);